module.exports = __webpack_public_path__ + "static/media/add-problem.09396e44.svg";